setTimeout(() => {
    if (typeof B2B) {
        let varriant = document.querySelectorAll('[bss-b2b-product-form-id] [bss-b2b-variant-click]')
        if (varriant.length) {
            varriant.forEach((e) => {
                e.addEventListener("click", function() {
                    document.querySelector('[bss-b2b-product-form-id] .price.price--large:has([bss-b2b-variant-id])').classList.add("bss-b2b-disable")
                    if (document.querySelector('[bss-b2b-product-form-id] .price.price--large .price__badge-sale')) {
                      document.querySelector('[bss-b2b-product-form-id] .price.price--large .price__badge-sale').classList.add("bss-b2b-disable")
                    }
                    setTimeout(() => {
                        BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
                    }, 700)
                    setTimeout(() => {
                        document.querySelector('[bss-b2b-product-form-id] .price.price--large:has([bss-b2b-variant-id])').classList.remove("bss-b2b-disable")
                        document.querySelector('[bss-b2b-product-form-id] .price.price--large .price__badge-sale').classList.remove("bss-b2b-disable")
                    }, 1000)

                });
            })
        }
    }
}, 2000)